export const isValidNumber = (value: string | undefined) => {
  //  returning true so the .required() check applies in the schema, rather than a formatting message
  if (!value) {
    return true;
  }

  const phoneNumberRegex = /^(0|(\+49)|0049)[0-9]{8,15}$/;
  const trimmedNumber = value?.replace(/\s/g, '');

  return phoneNumberRegex.test(trimmedNumber);
};
